import { Typography, TextField, Box, IconButton } from '@mui/material';
import { ReactComponent as CopyIcon } from 'assets/images/copy-icon.svg';

interface VariableDisplayProps {
  variableName: string | null;
  variableValue?: string | null;
}
export default function VariableDisplay({ variableName, variableValue }: VariableDisplayProps) {
  return (
    <Box marginBottom='5px'>
      <Box display='flex' alignItems='center' justifyContent='space-between' marginBottom='10px'>
        <Box width={250}>
          <Typography
            fontSize={'14px'}
            fontWeight={500}
            overflow={'hidden'}
            textOverflow={'ellipsis'}
            whiteSpace={'nowrap'}
          >
            {variableName}
          </Typography>
        </Box>
        <IconButton
          onClick={() => {
            navigator.clipboard.writeText(`[${variableName}]`);
          }}
        >
          <CopyIcon />
        </IconButton>
      </Box>

      <TextField
        fullWidth
        disabled
        value={variableValue ? variableValue : ''}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            height: '48px',
          },
        }}
      />
    </Box>
  );
}
